/**
 * Single FAQ entry
 */

//  Deps
import { combineRules } from "fela";
import { fluid } from "~/styleguide/utils";
import { createComponent, FelaComponent } from "react-fela";
import { textStyles } from "~/styleguide/typography";

// Components
import Item from "./item";

export default function Group({ group }) {
    const { heading, features } = group;

    return (
        <Container>
            {/* Heading */}
            {heading && (
                <FelaComponent
                    as="h3"
                    style={combineRules(
                        textStyles.resourceHeading,
                        featureGroupHeading
                    )}
                >
                    <span dangerouslySetInnerHTML={{ __html: heading }} />
                </FelaComponent>
            )}

            {features && features.length && (
                <Listing>
                    {features &&
                        features.map((feature, index) => {
                            return <Item key={index} feature={feature} />;
                        })}
                </Listing>
            )}
        </Container>
    );
}

const Container = createComponent(() => ({
    extend: [fluid("marginBottom", { min: 30, max: 70 })],
    ":last-of-type": {
        marginBottom: 0
    }
}));

const Listing = createComponent(() => ({}));

const featureGroupHeading = {
    marginBottom: 20,
    display: "block"
};
